export const INNOVOLT_ASSURED_LIST = [
  {
    icon: "https://assets.innovolt.in/icons/battery-warrenty-icon.svg",
    title: "Battery Warranty",
  },
  {
    icon: "https://assets.innovolt.in/icons/negotiable-icon.svg",
    title: "Negotiable Deals",
  },
  {
    icon: "https://assets.innovolt.in/icons/oem-service-icon.svg",
    title: "OEM Service",
  },
  {
    icon: "https://assets.innovolt.in/icons/technical-support-icon.svg",
    title: "Technical Support",
  },
];

export const VEHICLE_PRODUCT_SLIDER_IMAGE_LIST = [
  "https://static.wixstatic.com/media/a66d89_fbcfc2bc6c074af9883e38e34cb00aaf~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_fbcfc2bc6c074af9883e38e34cb00aaf~mv2.jpeg",
  "https://static.wixstatic.com/media/a66d89_bea7d199113a4acf971ebdd2cc00d189~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_bea7d199113a4acf971ebdd2cc00d189~mv2.jpeg",
  "https://static.wixstatic.com/media/a66d89_baa5444171784344b5ea40af901f0359~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_baa5444171784344b5ea40af901f0359~mv2.jpeg",
  "https://static.wixstatic.com/media/a66d89_9017aeb559b44bee8246743ea931975e~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_9017aeb559b44bee8246743ea931975e~mv2.jpeg",
  "https://static.wixstatic.com/media/a66d89_14b6fc7b5ac04150bc2d4860860fff56~mv2.jpg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_14b6fc7b5ac04150bc2d4860860fff56~mv2.jpg",
];
